// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9565edb7","75":"6e3dfee7","388":"e072720a","942":"8f6fcaaa"}[chunkId] + ".chunk.js";
};